export const USER_INFO = 'USER_INFO'; // 用户信息